import React from "react";

const socialMediaIcons = [
  {
    src: "https://cdn-icons-png.flaticon.com/128/1384/1384031.png",
    alt: "instagram",
  },
  {
    src: "https://cdn-icons-png.flaticon.com/128/20/20837.png",
    alt: "facebook",
  },
  {
    src: "https://cdn-icons-png.flaticon.com/128/2111/2111774.png",
    alt: "Whatsapp",
  },
];

const SharePostButton = ({ url, title }) => {
  const handleShareClick = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: title,
          url: url,
        });
        console.log("Post shared successfully!");
      } else {
        console.log("Share feature not supported");
        alert("Share feature is not supported on this device.");
      }
    } catch (err) {
      console.error("Error sharing the post:", err);
    }
  };

  return (
    <button
      onClick={handleShareClick}
      style={{
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        {socialMediaIcons.map((icon, index) => (
          <img
            key={index}
            src={icon.src}
            alt={icon.alt}
            width={18}
            height={18}
          />
        ))}
      </div>
    </button>
  );
};

export default SharePostButton;